import { API } from 'aws-amplify';
import axios from 'axios';

import { EnumAppDocType } from '../../private/redux/scholarship.models';

interface UploadFileResponse {
  status: number;
}

export const getFileStatus = async (applicationId: string, fileType: EnumAppDocType) => {
  const apiPath = `/files/${applicationId}/${fileType}`;
  const response = await API.get('service-mtpf', apiPath, {});

  return response.data[0];
};

const getSignedUrl = async (filePath: string, apiPath = '/file/signed-url'): Promise<string> => {
  const body = {
    filePath
  };

  try {
    const response = await API.post('service-mtpf', apiPath, { body });
    const parsedUrl = new URL(response.data);

    return parsedUrl.href;
  } catch (error) {
    console.log('Error: getSignedUrl');
    throw error;
  }
};

export const uploadFile = async (file: File, filePath: string, section: string): Promise<UploadFileResponse> => {
  const formData = file;
  const signedUrl = await getSignedUrl(filePath);
  const headers = {
    'x-amz-acl': 'bucket-owner-full-control',
    'content-type': file.type,
    'x-amz-meta-file-data': section,
    'x-amz-server-side-encryption': 'AES256'
  };

  const response = await axios.put(signedUrl, formData, { headers });

  return { status: response.status };
};
